import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { RoleEnum } from 'acl-cloud-lib';
import { AuthHelperService } from './auth-helper.service';
import { Subject, takeUntil } from 'rxjs';

@Directive({
  selector: '[VisibleForRoles]',
  standalone: true
})
export class VisibleForRolesDirective implements OnInit {

  private _unSubscriber = new Subject<void>();

  private _roles: RoleEnum[] = [];
  @Input() set VisibleForRoles(r: string[]) {
    this._roles = r.map((role) => this._authHelperService.stringToRoleEnum(role));
  }
  get VisibleForRoles(): string[] {
    return this._roles.map((role) => this._authHelperService.roleEnumToString(role));
  }

  constructor(
    private readonly _elementRef: ElementRef,
    private readonly _authHelperService: AuthHelperService
  ) { }

  ngOnInit() {
    let defaultdisplay = this._elementRef.nativeElement.style.display
    this._authHelperService.userHasOneOfRoles(this._roles).pipe(takeUntil(this._unSubscriber)).subscribe((hasRole) => {
      if (hasRole) {
        this._elementRef.nativeElement.style.display = defaultdisplay;
      } else {
        this._elementRef.nativeElement.style.display = 'none';
      }
    });
  }

  ngOnDestroy() {
    this._unSubscriber.next();
    this._unSubscriber.complete();
  }
}